module.exports = __webpack_public_path__ + "static/progressbarBack-43379a8e1512b188d26afa41d556553c.png";